import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Heart, MessageCircle, Trophy } from "lucide-react";
import { mediaUrl } from "../lib/api";

const FADE_IN = { opacity: 0, y: 24 };
const FADE_VISIBLE = { opacity: 1, y: 0 };
const FADE_TRANSITION = { duration: 0.7, ease: [0.16, 1, 0.3, 1] };

export const FeaturedMemory = ({ post }) => {
  if (!post) return null;
  return (
    <motion.section
      data-testid="featured-memory"
      initial={FADE_IN}
      animate={FADE_VISIBLE}
      transition={FADE_TRANSITION}
      className="mb-12 overflow-hidden rounded-3xl border border-[#B85328]/30 bg-[#1F1A17] text-[#FBF8F3] shadow-2xl"
    >
      <div className="grid md:grid-cols-[1.2fr_1fr]">
        <Link to={`/ricordo/${post.post_id}`} data-testid="featured-memory-link" className="block bg-black">
          {post.media_type === "video" ? (
            <video src={mediaUrl(post.media_url)} controls preload="metadata" className="h-full max-h-[420px] w-full object-cover" />
          ) : (
            <img src={mediaUrl(post.media_url)} alt={`${post.dog_name} — ricordo della settimana`} className="h-full max-h-[420px] w-full object-cover" />
          )}
        </Link>
        <div className="flex flex-col justify-center p-7 sm:p-10">
          <p className="flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.25em] text-[#E0A484]">
            <Trophy size={13} /> Ricordo della settimana
          </p>
          <Link to={`/cani/${encodeURIComponent(post.dog_name)}`} data-testid="featured-memory-dog-link">
            <h2 className="font-display mt-4 text-3xl font-semibold leading-tight sm:text-4xl transition-colors hover:text-[#E0A484]">
              {post.dog_name}
            </h2>
          </Link>
          {post.caption && <p className="mt-3 text-sm leading-relaxed text-[#CFC0B2] sm:text-base">{post.caption}</p>}
          <p className="mt-4 text-xs text-[#8C7B6E]">condiviso da {post.author_name}</p>
          <div className="mt-6 flex items-center gap-5 text-sm font-semibold text-[#E0A484]">
            <span data-testid="featured-memory-likes" className="flex items-center gap-1.5">
              <Heart size={16} fill="#E0A484" /> {post.likes_count} {post.likes_count === 1 ? "cuoricino" : "cuoricini"}
            </span>
            <span className="flex items-center gap-1.5 text-[#CFC0B2]">
              <MessageCircle size={16} /> {post.comments_count}
            </span>
          </div>
        </div>
      </div>
    </motion.section>
  );
};
